import { ActionTypes } from "redux/reducers/retentionOutputs/types";
import { api_get, api_post, api_put, api_delete, api_get_blob, api_put_multipart, PROYECT } from "services/api";
import {
  setSnackbar,
  startRequestComp,
  stopRequestComp,
} from "../search/searchActions";

const { SET_RETENTION_OUTPUTS, ADD_RETENTION_OUTPUT, UPDATE_RETENTION_OUTPUT, REMOVE_RETENTION_OUTPUT, SET_FILTERS } = ActionTypes;

const baseUrl = `${process.env.REACT_APP_URL}${PROYECT}`;

const triggerDownload = (blob, filename) => {
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
};

export const getRetentionOutputs = (station, month, year) => {
  const url = `${baseUrl}/retention_payments?idStation=${station?.id}&month=${month}&year=${year}`;
  return async (dispatch) => {
    dispatch(startRequestComp("loadingRetentionOutputs"));
    try {
      const resp = await api_get(url);
      if (!resp || resp.length === 0) {
        dispatch(setSnackbar("No se encontraron registros", "warning"));
      }
      dispatch({ type: SET_RETENTION_OUTPUTS, payload: resp || [] });
    } catch (error) {
      dispatch(setSnackbar(error));
    } finally {
      dispatch(stopRequestComp("loadingRetentionOutputs"));
    }
  };
};

export const createRetentionOutput = (payments, onSuccess) => async (dispatch) => {
  dispatch(startRequestComp("savingRetentionOutput"));
  const url = `${baseUrl}/retention_payments`;
  const paymentsList = Array.isArray(payments) ? payments : [payments];
  try {
    const resp = await api_post(url, { payments: paymentsList });
    const created = Array.isArray(resp) ? resp[0] : resp;
    dispatch({ type: ADD_RETENTION_OUTPUT, payload: created });
    dispatch(setSnackbar("Registro creado exitosamente", "success"));
    onSuccess && onSuccess();
  } catch (error) {
    dispatch(setSnackbar(error));
  } finally {
    dispatch(stopRequestComp("savingRetentionOutput"));
  }
};

export const setRetentionOutputsFilters = (key = "", value) => ({
  type: SET_FILTERS,
  payload: { key, value },
});

export const updateRetentionOutputStatus = (id, status, onSuccess) => async (dispatch) => {
  dispatch(startRequestComp("updatingRetentionOutput"));
  const url = `${baseUrl}/retention_payments/${id}`;
  try {
    const resp = await api_put(url, { status });
    dispatch({
      type: UPDATE_RETENTION_OUTPUT,
      payload: resp,
    });
    dispatch(setSnackbar("Registro actualizado exitosamente", "success"));
    onSuccess && onSuccess();
  } catch (error) {
    dispatch(setSnackbar(error));
  } finally {
    dispatch(stopRequestComp("updatingRetentionOutput"));
  }
};

export const getCustomerBalance = ({ idCustomer, month, year, onSuccess, idStation }) => {
  const url = `${baseUrl}/retentions/balance?idCustomer=${idCustomer}&month=${month}&year=${year}&idStation=${idStation}`;
  return async (dispatch) => {
    try {
      const resp = await api_get(url);
      onSuccess && onSuccess(resp);
    } catch (error) {
      dispatch(setSnackbar(error));
    }
  };
};

export const deleteRetentionOutput = (id, onSuccess) => async (dispatch) => {
  dispatch(startRequestComp("updatingRetentionOutput"));
  const url = `${baseUrl}/retention_payments/${id}`;
  try {
    await api_delete(url);
    dispatch({ type: REMOVE_RETENTION_OUTPUT, payload: id });
    dispatch(setSnackbar("Registro eliminado exitosamente", "success"));
    onSuccess && onSuccess();
  } catch (error) {
    dispatch(setSnackbar(error));
  } finally {
    dispatch(stopRequestComp("updatingRetentionOutput"));
  }
};

export const downloadReceipt = (id) => async (dispatch) => {
  try {
    const response = await api_get_blob(`${baseUrl}/retention_payments/${id}/receipt`);
    triggerDownload(response.data, `recibo-${id}.pdf`);
  } catch (error) {
    dispatch(setSnackbar("Error al descargar el recibo"));
  }
};

export const downloadEvidence = (id) => async (dispatch) => {
  try {
    const response = await api_get_blob(`${baseUrl}/retention_payments/${id}/evidence`);
    const contentType = response.headers["content-type"] || "application/octet-stream";
    const ext = contentType.includes("pdf") ? "pdf" : contentType.includes("png") ? "png" : "jpg";
    const blob = new Blob([response.data], { type: contentType });
    triggerDownload(blob, `evidencia-${id}.${ext}`);
  } catch (error) {
    dispatch(setSnackbar("Error al descargar la evidencia"));
  }
};

export const uploadEvidence = (id, file, onSuccess) => async (dispatch) => {
  dispatch(startRequestComp("uploadingEvidence"));
  const formData = new FormData();
  formData.append("file", file);
  try {
    const resp = await api_put_multipart(`${baseUrl}/retention_payments/${id}/evidence`, formData);
    dispatch({
      type: UPDATE_RETENTION_OUTPUT,
      payload: { id, urlEvidence: resp?.urlEvidence || true },
    });
    dispatch(setSnackbar("Evidencia subida exitosamente", "success"));
    onSuccess && onSuccess();
  } catch (error) {
    dispatch(setSnackbar("Error al subir la evidencia"));
    throw error;
  } finally {
    dispatch(stopRequestComp("uploadingEvidence"));
  }
};
